module.exports = __webpack_public_path__ + "img/kodi.d2d38145.svg";